import React from 'react';
import { DemoContestHeader } from "@/components/brandDemo/DemoContestHeader.jsx";
import { DemoMatchCard } from "@/components/brandDemo/DemoMatchCard.jsx";

export const DemoGameLayout = ({ contestData, matchScore, isGoalFlashing, onTeamClick, children }) => {
    return (
        <>
            <DemoContestHeader contestData={contestData} recentGoal={isGoalFlashing} />

            {contestData ? (
                <div className="px-6 pb-8 relative z-20">
                    <DemoMatchCard
                        fixture={contestData.fixture}
                        matchScore={matchScore}
                        isGoalFlashing={isGoalFlashing}
                        onTeamClick={onTeamClick}
                    />
                    {children}
                </div>
            ) : (
                <div className="animate-fade-in relative z-20">
                    {children}
                </div>
            )}
        </>
    );
};
